import './styles/static-page/app.scss';
// import './styles/ticket-styles/app.scss';
// start the Stimulus application
import './bootstrap';

// this "modifies" the jquery module: adding behavior to it
// the bootstrap module doesn't export/return anything
window.bootstrap = require('bootstrap');
const popoverTriggerList = [].slice.call(
  document.querySelectorAll('[data-bs-toggle="popover"]')
);
popoverTriggerList.map(function (el) {
  return new bootstrap.Popover(el);
});

// Lazy-load YouTube embeds coming from constructor-generated article content.
// The constructor exports raw `<iframe src="youtube.com/embed/...">` tags that we
// don't control, so instead of editing every article we replace them here, on
// every static page, with a click-to-load thumbnail (facade). This avoids
// fetching ~1MB of YouTube player JS/CSS for visitors who never press play.
document.querySelectorAll('iframe[src*="youtube.com/embed/"]').forEach(function (iframe) {
  const src = iframe.getAttribute('src');
  const match = src.match(/embed\/([^?&]+)/);
  if (!match) {
    return;
  }
  const videoId = match[1];
  const height = iframe.style.height || iframe.getAttribute('height') || '100%';

  const facade = document.createElement('div');
  facade.className = 'yt-lazy-embed';
  facade.setAttribute('role', 'button');
  facade.setAttribute('aria-label', 'Play video');
  facade.style.cssText =
    'position:relative;width:100%;height:' + height + ';cursor:pointer;' +
    'background:#000 url(https://i.ytimg.com/vi/' + videoId + '/hqdefault.jpg) center/cover no-repeat;';
  facade.innerHTML =
    '<svg viewBox="0 0 68 48" width="68" height="48" style="position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);">' +
    '<path d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,0,34,0,34,0S12.21,0,6.9,1.55C3.97,2.33,2.27,4.81,1.48,7.74C0,13.05,0,24,0,24' +
    's0,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19C12.21,48,34,48,34,48s21.79,0,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19' +
    'C68,34.95,68,24,68,24S68,13.05,66.52,7.74z" fill="#f00"></path>' +
    '<path d="M 45,24 27,14 27,34" fill="#fff"></path>' +
    '</svg>';

  facade.addEventListener(
    'click',
    function () {
      const realIframe = document.createElement('iframe');
      realIframe.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
      realIframe.width = '100%';
      realIframe.height = '100%';
      realIframe.style.border = '0';
      realIframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      realIframe.allowFullscreen = true;
      facade.replaceWith(realIframe);
    },
    { once: true }
  );

  iframe.replaceWith(facade);
});

